import { Box, MobileStepper } from "@mui/material";
const TweenScreenCheckpoints = [{ name: "Created/Opened", position: 0 }, { name: "Authenticated", position: 1 }, { name: "Environment Questions", position: 2 }, { name: "Personal Questions", position: 3 }, { name: "Adventure Selected", position: 4 }, { name: "Completed", position: 5 }]
const tScreenCheckpoints = [{ name: "Created/Opened", position: 0 }, { name: "Authenticated", position: 1 }, { name: "Environment Questions", position: 2 }, { name: "Personal Questions", position: 3 }, { name: "Survey Questions", position: 4 }, { name: "Completed", position: 5 }]
const envCheckpoints = ["EnvironmentQuestions", "FamilyQuestions", "DescribeAdultsQuestions"]
const personalCheckpoints = ["PersonalQuestions", "PersonalSupportQuestions", "PersonalProblemsQuestions"]
const surveyCheckpoints = ["HappyOrSadQuestions", "TiredOrAwakeQuestions", "HobbiesQuestions", "AtSchoolQuestions", "PhysicalSignsQuestions", "WorryQuestions", "SuicidalityQuestions", "AdventureComplete"]

// const TweenScreenCheckpoints = ["Opened", "Authenticated", "Environment Questions", "Personal Questions", "Adventure Selected", "Completed"]
// const tScreenCheckpoints = ["Opened", "Authenticated", "Environment Questions", "Personal Questions", "Survey Questions", "Completed"]
function pascalCaseToHumanReadable(text: string) {
    return text.replace(/([A-Z])/g, ' $1')
        .replace(/^./, function (str) { return str.toLocaleUpperCase(); })
}
// TODO: FIGURE OUT THE SEQUENCE FOR THIS 
function mapTweenScreenCheckpoints(checkpoint: string) {
    const currentCheckpoint = checkpoint === "Created" || checkpoint === "Opened" ? TweenScreenCheckpoints[0]
        : checkpoint === "AuthenticationSuccess" || checkpoint === "AvatarSelected" ?
            TweenScreenCheckpoints[1] :
            envCheckpoints.includes(checkpoint) ? TweenScreenCheckpoints[2] :
                personalCheckpoints.includes(checkpoint) ? TweenScreenCheckpoints[3] :
                    checkpoint === "AdventureSelected" ? TweenScreenCheckpoints[4] :
                        TweenScreenCheckpoints[5]

    return {
        currentCheckpoint: currentCheckpoint,
        values: TweenScreenCheckpoints
    }
}
function mapTScreenCheckpoints(checkpoint: string) {
    const currentCheckpoint = checkpoint === "Created" || checkpoint === "Opened" ? tScreenCheckpoints[0]
        : checkpoint === "AuthenticationSuccess" || checkpoint === "AvatarSelected" ?
            tScreenCheckpoints[1] :
            envCheckpoints.includes(checkpoint) ? tScreenCheckpoints[2] :
                personalCheckpoints.includes(checkpoint) ? tScreenCheckpoints[3] :
                    surveyCheckpoints.includes(checkpoint) ? tScreenCheckpoints[4] :
                        tScreenCheckpoints[5]

    return {
        currentCheckpoint: currentCheckpoint,
        values: tScreenCheckpoints
    }
}
type CheckpointCellProps = {
    checkpoint: string,
    sessionType: string // NOTE: MAKE THIS A TYPE EVENTUALLY AND GET RID OF THE PARTIAL/FULLL TYPING 

}
function CheckpointCell({ checkpoint, sessionType }: CheckpointCellProps) {
    const processedCheckpointData = sessionType === "TweenScreen" ? mapTweenScreenCheckpoints(checkpoint) : sessionType === "tScreen" ? mapTScreenCheckpoints(checkpoint) : { currentCheckpoint: { name: "", position: 0 }, values: [] };
    const { currentCheckpoint, values } = processedCheckpointData
    return (
        <Box>
            <Box sx={{ marginBottom: .2 }}>
                {pascalCaseToHumanReadable(currentCheckpoint?.name)}
            </Box>
            <Box display="flex" sx={{ width: '100%' }}>
                <MobileStepper position='static' variant="dots" activeStep={currentCheckpoint?.position ?? 0} steps={(values.length ?? 1)}
                    sx={(theme) => ({
                        background: 'transparent',
                        padding: 0,
                        margin: 0,
                        flexGrow: 1,
                        '& .MuiMobileStepper-dotActive': {
                            background: theme.palette.info.light
                        }
                    })} backButton={undefined} nextButton={undefined} />
            </Box>
        </Box>
    )
}

export default CheckpointCell